<template>
    <div class='groupusers'>
        <!-- center -->
        <div class='center'>
            <div class='btn'>
                <el-button type='primary' style='width: 100px;' plain @click="foraddnew('新增用户')">新增</el-button>
                <el-button type='danger' style='width: 100px;' plain @click='handleDelete()'>删除</el-button>
                <!--				<el-button type="primary" style="width: 100px;" plain @click="handleCommand()">导入用户</el-button>-->
                <!--				<el-button type="primary" plain style="width: 100px;" @click="downloadDefaultTemplate">-->
                <!--					下载模板-->
                <!--					<i class="el-icon-download  el-icon&#45;&#45;right"></i>-->
                <!--				</el-button>-->
            </div>
            <div class='search' style='width: 330px;'>
                <el-input placeholder='搜索姓名、用户名、手机、邮箱' prefix-icon='el-icon-search' v-model='likeSearchvalue' clearable
                          @input='changeserch'></el-input>
            </div>
        </div>

        <div class='table'>
            <div class='tableh'>
                <el-table ref='multipleTable' :data='tableData.data' style='width: 100%'
                          @selection-change='changeselection' :height='tableHeight' border>
                    <el-table-column type='selection' width='55' align='center' :selectable='selectInit'>
                    </el-table-column>
                    <el-table-column prop='userName' label='姓名'></el-table-column>
                    <el-table-column prop='userCode' label='用户名'></el-table-column>
                    <el-table-column prop='roleName' label='用户角色'></el-table-column>
                    <el-table-column prop='newuserType' label='角色类型'></el-table-column>
                    <el-table-column prop='phone' label='手机'></el-table-column>
                    <el-tablebi-column prop='email' label='邮箱'></el-tablebi-column>
                    <el-table-column prop='state' label='用户状态'>
                        <template slot-scope='scope'>
                            <p v-if="scope.row.state === '1'">停用</p>
                            <p v-if="scope.row.state === '0'">正常</p>
                        </template>
                    </el-table-column>
                    <el-table-column label='操作' align='center' width='200px'>
                        <template slot-scope='scope'>
                            <div class='Centerupdown'>
                                <el-button size='text' type='primary'
                                           @click="handleCheck(scope.$index, scope.row, '查看详情')">
                                    预览
                                </el-button>
                                <el-button size='text' type='primary'
                                           @click="handleEdit(scope.$index, scope.row, '编辑详情')">
                                    编辑
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class='buttompage'>
                <el-pagination class='pagination' :key='elementui_page_component_key'
                               @size-change='handleSizeChange' @current-change='handleCurrentChange'
                               :page-sizes='pwm.limits'
                               :page-size='pwm.limit' :current-page='pwm.page'
                               layout='total, sizes, prev, pager, next, jumper' :total='pwm.count'>
                </el-pagination>
            </div>

            <!-- 弹层 -->
            <!-- 添加弹层 -->
            <el-dialog class='dialog' v-dialogDrag :visible.sync='dialogVisible2' width='800px'
                       :close-on-click-modal='false' :title='title'>
                <div class='form'>
                    <el-form :model='ruleForm' :rules='rules' ref='ruleForm' label-width='100px' class='demo-ruleForm'>
                        <el-form-item label='姓名' prop='userName'>
                            <el-input v-model='ruleForm.userName' :disabled="title == '查看详情'"></el-input>
                        </el-form-item>
                        <el-form-item label='手机号' prop='phone'>
                            <el-input v-model='ruleForm.phone' :disabled="title == '查看详情'"></el-input>
                        </el-form-item>
                        <el-form-item label='用户名' prop='userCode'>
                            <el-input v-model='ruleForm.userCode' :disabled="title == '查看详情'"></el-input>
                        </el-form-item>
                        <el-form-item prop='email' label='邮箱'>
                            <el-input v-model='ruleForm.email' :disabled="title == '查看详情'"></el-input>
                        </el-form-item>
                        <el-form-item label='用户角色' prop='userType'>
                            <el-select v-model='ruleForm.roleId' placeholder='请选择' style='width: 100%;'
                                       :disabled="title == '查看详情'">
                                <el-option v-for='item in roleComboData' :key='item.value' :label='item.label'
                                           :value='item.value'>
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label='状态' prop='state'>
                            <el-select v-model='ruleForm.state' :disabled="title == '查看详情'">
                                <el-option label='停用' value='1'></el-option>
                                <el-option label='正常' value='0'></el-option>
                            </el-select>
                        </el-form-item>
                        <div style='padding-left: 15px;width:100%'>
                            <span class='ar-title'>关联实体信息</span>
                            <div style='padding-top: 10px;'>
                                <el-button plain style='width: 80px;' @click='addRelCompanyClickFun()'>添加</el-button>
                                <el-button plain style='width: 80px;' @click='delRelCompanyClickFun()'>删除</el-button>
                            </div>
                            <div style='padding-top: 10px;width:100%'>
                                <el-table :data='ruleFormcompanyList' border stripe width='100%' height='250px'
                                          class='table' ref='relCompanyTable'
                                          @row-click='clickUserRelCompanyRowByChecked'>
                                    <el-table-column type='selection' width='55' align='center' label='序号'>
                                    </el-table-column>
                                    <el-table-column prop='name' label='实体名称' show-overflow-tooltip></el-table-column>
                                    <el-table-column prop='taxNumber' label='实体税号' show-overflow-tooltip>
                                    </el-table-column>
                                    <el-table-column prop='qiybh' label='实体代码' show-overflow-tooltip></el-table-column>
                                    <el-table-column prop='state' label='当前状态' :formatter='stateFormat'>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </el-form>
                    <div class='buttomanniu'>
                        <el-button type='primary' @click="submitForm('ruleForm')" v-if="title != '查看详情'">保存</el-button>
                        <el-button @click='returnForm2()'>返回</el-button>
                    </div>
                </div>
            </el-dialog>
            <!-- 关联实体信息 - 实体信息显示 -->
            <el-dialog :visible.sync='showCompanyDataDialogVisible' width='600px' :close-on-click-modal='false'
                       :title="'公司信息'"
                       v-dialogDrag class='dialog'>
                <div class='custom-dialog'>
                    <div style='padding-top: 10px;'>
                        <el-table :data='allCompanyList' border stripe height='300px' class='table' ref='companyTable'
                                  @row-click='clickCompanyTableRowByChecked'>
                            <el-table-column type='selection' width='55' align='center'></el-table-column>
                            <el-table-column prop='name' label='实体名称' show-overflow-tooltip></el-table-column>
                            <el-table-column prop='taxNumber' label='实体税号' show-overflow-tooltip></el-table-column>
                            <el-table-column prop='qiybh' label='实体代码' show-overflow-tooltip></el-table-column>
                            <el-table-column prop='state' label='当前状态' :formatter='stateFormat'></el-table-column>
                        </el-table>
                    </div>
                </div>
                <div class='buttomanniu'>
                    <el-button type='primary' @click='saveUserRelCompanyClickFun()'>保存</el-button>
                    <el-button @click='showCompanyDataDialogVisible = false'>返回</el-button>
                </div>
            </el-dialog>
            <el-dialog :title="'选择文件'" :visible.sync='daorudiag' width='700px' :close-on-click-modal='false'
                       append-to-body
                       v-dialogDrag>
                <div class='Verticalcenter' style='margin-top: 32px;'>
                    <div class='Centerhorizontally' style='margin-left: 260px;'>
                        <el-input style='width: 300px;margin-right: 16px;' disabled v-model='upfilename'></el-input>

                        <label style='display: flex;align-items: center;'>
                            <div class='Centerhorizontally bt1'>选择文件</div>
                            <input type='file' class='sendinput' @change='uploadFile($event)' :value='filestate' />
                        </label>
                    </div>

                    <div class='buttomanniu' style='margin-top: 30px;'>
                        <el-button type='primary' @click='sureupload'>确定</el-button>
                        <el-button @click='daorudiag = false'>关闭</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import {
    getUserById,
    getUserList,
    saveUser,
    deleteUsersByType,
    deleteUser,
    updatePasswordHashUser,
    getRoleListByCompany,
    getCompanyListByGroup,
    getCompanyDataByCurrGroupId,
    getUserAndCompanyMapping,
    uploadUserExcel
} from '../../../api/home.js';
import http from '../../../../configHttp.js';

export default {

    data() {
        var validatePass = (rule, value, callback) => {
            let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,}$/;
            if (value == '' || value == '********') {
                callback();
            } else if (!reg.test(value)) {
                callback(new Error('密码需包含大小写字母、数字且大于8位'));
            } else {
                callback();
            }
        };
        var verifPassword = (rule, value, callback) => {

            if (!reg.test(value)) {
                callback(new Error('只能输入数字'));
            } else {
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value == '' && this.ruleForm.password == '') {
                callback();
            } else if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value != this.ruleForm.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        var validateTel = (rule, value, callback) => {
            if (value != '') {
                const reg = /^[1][3,4,5,6,7,8][0-9]{9}$/;
                if (reg.test(value)) {
                    callback();
                } else {
                    callback(new Error('请输入正确的手机号'));
                }
            } else {
                callback();
            }
        };
        return {
            useropj: {},
            glytitle: ['系统设置', '人员管理'],
            daorudiag: false,
            daorutitle: ['选择文件'],
            likeSearchvalue: '',
            title: '查看详情',
            rules: {
                userName: [{
                    required: true,
                    message: '请输入名字',
                    trigger: 'blur'
                }, {
                    trigger: 'blur'
                }],
                phone: [{
                    validator: validateTel,
                    trigger: 'blur'
                }],
                userCode: [{
                    required: true,
                    message: '请输入用户名',
                    trigger: 'blur'
                }, {
                    trigger: 'blur'
                }],
                //password: [{validator: validatePass, trigger: 'blur' }],
                email: [{
                    required: true,
                    type: 'email',
                    message: '请输入正确的邮箱地址',
                    trigger: 'blur'
                }],
                checkPass: [{
                    validator: validatePass2,
                    trigger: 'blur'
                }]
            },
            ruleForm: {
                userName: '',
                phone: '',
                userCode: '',
                email: '',
                password: '',
                checkPass: '',
                state: '0',
                userType: '',
                companyGroupName: '',
                companyGroupId: '',
                version: '',
                roleId: '',
                companyIds: '',
                companyList: []
            },
            choosejt: '所有',
            choosejtid: '',
            /* 可建人员类型	 */
            username: '一般用户',
            userType: '3',
            useralllist: [{
                label: '超级管理员',
                value: '0'
            },
                {
                    label: '集团管理员',
                    value: '1'
                },
                {
                    label: '实体管理员',
                    value: '2'
                }, {
                    label: '一般用户',
                    value: '3'
                }
            ],

            input21: '',
            dialogVisible2: false,
            dialogVisible3: false,

            AllCompanyGrouplist: [],

            //table数据
            tableData: {
                data: [],
                this: this
            },
            ids: '',
            pwm: {
                count: 0,
                limit: 100,
                page: 1,
                limits: [50, 100, 200, 500]
            },
            userRelCompanyData: [],
            showCompanyDataDialogVisible: false,
            currGroupData: '', //  当前集团信息
            allCompanyList: '', //  当前集团下所有实体信息
            disabled: false, //  字段是否禁用
            disabledUserCode: false, //  用户名是否禁用
            showRelCompanyOpBtn: false,
            showColumn: false, //id列是否隐藏
            roleComboData: [],
            upfilename: '',
            filestate: '',
            upfile: '',
            ruleFormcompanyList: [],
            tableHeight: '',
            currentpage: 1,
            elementui_page_component_key: ''

        };
    },
    mounted() {
        this.$nextTick(() => {
            this.tableHeight = this.diagheight();
            this.$refs.multipleTable.doLayout();
            window.onresize = () => {
                this.tableHeight = this.diagheight();
                this.$refs.multipleTable.doLayout();
            };
        });
    },
    created() {
        this.useropj = JSON.parse(localStorage.getItem('useropj'));
        this.choosejt = this.useropj.currCompany.companyGroup.name; //获取当前集团名称
        this.choosejtid = this.useropj.currCompany.companyGroup.id; //获取当前集团id
        this.ruleForm.companyGroupName = this.useropj.currCompany.companyGroup.name; //获取当前集团名称
        this.ruleForm.companyGroupId = this.useropj.currCompany.companyGroup.id; //获取当前集团id
        this.getUserList();
    },
    methods: {
        selectInit(row, index) {
            // console.log(row);
            return row.roleType !== '1';
        },
        /* 搜索 */
        changeserch(e) {
            this.currentpage = 1;
            this.elementui_page_component_key++;
            this.page = 1;
            this.likeSearchvalue = e;
            this.getUserList();
        },
        /* 	选择人员类型 */
        choosemembertype(e) {
            this.userType = e;
        },
        /* 查看弹框弹出*/
        handleCheck(index, row, title) {
            this.title = title;
            this.$nextTick(() => {
                this.$refs['ruleForm'].clearValidate();
            });
            this.showRelCompanyOpBtn = false;
            this.ruleFormcompanyList = [];
            this.getCompanyDataByCurrGroupId(row.companyGroupId);
            // this.getRoleListByGroupId(true);
            getRoleListByCompany().then(res => {
                if (res.data.success) {
                    this.assembleRoleComboData(res.data.obj).then(() => {
                        this.getUserById(row.id);
                    });
                } else {
                    this.$message.error('加载当前集团下用户角色信息错误：' + res.data.message);
                }
            }, error => {
                this.$message.error('加载当前集团下用户角色信息错误：' + error);
            });
            this.getUserAndCompanyMapping(row.id);
            console.log(this.ruleForm);
        },
        /* 编辑弹框弹出 */
        handleEdit(index, row, title) {
            if (this.$refs['ruleForm']) {
                this.$nextTick(() => {
                    this.$refs['ruleForm'].clearValidate();
                });
            }
            this.title = title;
            this.showRelCompanyOpBtn = true;
            this.ruleFormcompanyList = [];
            // this.getRoleListByGroupId();
            getRoleListByCompany().then(res => {
                if (res.data.success) {
                   this.assembleRoleComboData(res.data.obj).then(() => {
                       this.getUserById(row.id, 'update');
                    });
                } else {
                    this.$message.error('加载当前集团下用户角色信息错误：' + res.data.message);
                }
            }, error => {
                this.$message.error('加载当前集团下用户角色信息错误：' + error);
            });
            this.getCompanyDataByCurrGroupId(row.companyGroupId);
            this.getUserAndCompanyMapping(row.id);
        },
        /* 	新增用户弹出*/
        foraddnew(title) {
            this.$nextTick(() => {
                this.$refs['ruleForm'].clearValidate();

            });
            this.dialogVisible2 = true;
            this.title = title;
            this.showRelCompanyOpBtn = true;

            this.getCompanyDataByCurrGroupId(this.choosejtid);
            this.getRoleListByGroupId();
            Object.keys(this.ruleForm).map(key => ((this.ruleForm[key] = ''), (this.ruleForm['companyGroupName'] = this
                .choosejt), (this.ruleForm['companyGroupId'] = this.choosejt)));
            this.ruleFormcompanyList = [this.useropj.currCompany]; // 新增用户默认关联当前实体
            this.ruleForm.state = '0';
        },

        /* 用户保存，编辑 */
        submitForm(formName) {
            this.ruleForm.checkPass = this.ruleForm.checkPass.replace('********', '');
            this.ruleForm.password = this.ruleForm.password.replace('********', '');
            if (this.ruleFormcompanyList.length == 0) {
                this.$message.error('至少关联一个实体');
                return;
            }
            console.log(this.ruleForm);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.title == '新增用户') {
                        this.addUser();
                    } else if (this.title == '编辑详情') {
                        this.updateUser();
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        handleSizeChange(val) {
            this.pwm.limit = val;
            this.getUserList();
        },
        handleCurrentChange(val) {
            this.pwm.page = val;
            this.getUserList();
        },
        /* 返回 */
        returnForm2() {
            this.dialogVisible2 = false;
        },

        /* 多选 */
        changeselection(e) {
            this.ids = '';
            e.forEach((item, index) => {
                this.ids = this.ids + item.id + ',';
            });
            var reg = /,$/gi;
            this.ids = this.ids.replace(reg, '');
        },
        /* 删除 */
        handleDelete() {
            this.$confirm('是否确认将删除用户?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    if (this.ids == '') {
                        this.$message({
                            type: 'info',
                            message: '请选择要删除的元素'
                        });
                    } else {
                        this.deleteUsers(this.ids);
                    }
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
        },

        /* 	查看用户 */
        getUserById(id, f) {
            let params = id;
            getUserById(params).then(res => {
                this.ruleForm = [];
                res.data.obj.checkPass = '********';
                res.data.obj.password = '********';
                if (!res.data.obj.roleId) {
                    res.data.obj.roleId = 0;
                }
                this.ruleForm = res.data.obj;

                if (this.ruleForm.roleType == '1' && this.ruleForm.roleId) {
                    console.log('preview');
                    this.roleComboData.push({
                        value: this.ruleForm.roleId,
                        label: this.getRoleLabel({
                            roleType: this.ruleForm.roleType,
                            roleName: this.ruleForm.roleName
                        })
                    });
                }
            });
        },
        /* 	获取集团下用户列表 */
        getUserList() {
            if (this.choosejtid == '') {
                this.choosejtid = null;
            }
            let search = {};
            if (this.choosejtid == '' || this.choosejtid == null) {
                // search={userType:"2,3"}
            } else {
                search = {
                    groupId: this.choosejtid
                };
            }
            search.likeSearch = this.likeSearchvalue;
            this.pwm.search = search;
            getUserList(this.pwm).then(res => {
                this.pwm.count = res.data.count;
                this.tableData.data = res.data.data;
                this.tableData.data.forEach(item => {
                    item.newuserType = this.typetostring(item.userType);
                });
            });
        },
        /* 	新增用户 */
        addUser() {
            let params = {};
            params = this.ruleForm;
            params.companyIds = '';
            this.ruleForm.companyGroupId = this.choosejtid;
            this.ruleForm.companyGroupName = this.choosejt;
            if (!this.ruleFormcompanyList || this.ruleFormcompanyList.length == 0) {
                this.$message.error('请选择关联实体信息。');
                return;
            }
            if (this.ruleFormcompanyList) {
                for (let i = 0; i < this.ruleFormcompanyList.length; i++) {
                    if (this.ruleFormcompanyList[i].id) {
                        params.companyIds += this.ruleFormcompanyList[i].id + ',';
                    }
                }
            }
            params.userType = this.userType;
            params.companyList = this.companyList;
            saveUser(params).then(res => {
                if (res.data.success) {
                    this.getUserList();
                    this.dialogVisible2 = false;
                }
            });
        },
        /* 批量删除用户 */
        deleteUsers(ids) {
            let params = ids;
            deleteUsersByType(params).then(res => {
                if (res.data.success) {
                    this.getUserList();
                    this.$message.success(this.$tolertJSON[4004]);
                    this.dialogVisible2 = false;
                } else {
                    this.$message.error(res.data.message);
                }
            });
        },
        /* 删除用户 */
        deleteUser(id) {
            let params = id;
            deleteUser(params).then(res => {
                if (res.data.success) {
                    this.getUserList();
                    this.$message.success(this.$tolertJSON[4003]);
                    this.dialogVisible2 = false;
                } else {
                    this.$message.error(res.data.message);
                }
            });
        },
        /* 更新用户 */
        updateUser() {
            let params = {};
            params = this.ruleForm;
            params.companyIds = '';
            if (!this.ruleFormcompanyList || this.ruleFormcompanyList.length == 0) {
                this.$message.error('请选择关联实体信息。');
                return;
            }
            for (let i = 0; i < this.ruleFormcompanyList.length; i++) {
                params.companyIds += this.ruleFormcompanyList[i].id + ',';
            }
            params.companyList = this.companyList;
            //params.userType = this.userType;
            updatePasswordHashUser(params).then(res => {
                if (res.data.success) {
                    this.getUserList();
                    this.dialogVisible2 = false;
                }
            });
        },
        getRoleListByGroupId(preview) { //  获取当前集团下的所有用户角色数据
            getRoleListByCompany().then(res => {
                if (res.data.success) {
                    this.assembleRoleComboData(res.data.obj).then(() => {
                        if (preview && this.ruleForm.roleId) {
                            console.log('preview');
                            this.roleComboData.push({
                                value: this.ruleForm.roleId,
                                label: this.getRoleLabel({
                                    roleType: this.ruleForm.roleType,
                                    roleName: this.ruleForm.roleName
                                })
                            });
                        }
                    });
                } else {
                    this.$message.error('加载当前集团下用户角色信息错误：' + res.data.message);
                }
            }, error => {
                this.$message.error('加载当前集团下用户角色信息错误：' + error);
            });
        },
        async assembleRoleComboData(roleData) { //  拼接用户角色下拉数据
            let roleComboData = [{
                value: 0,
                label: '无角色权限'
            }];
            if (roleData && roleData.length > 0) {
                roleData.forEach(role => {
                    roleComboData.push({
                        value: role.id,
                        label: this.getRoleLabel(role)
                    });
                });
            }
            this.roleComboData = roleComboData;
        },
        // 获取显示在页面上的用户类型
        getRoleLabel(role) {
            let prefix = '';
            if (role.roleType == '1') {
                prefix = '集团管理员-';
            }
            if (role.roleType == '2') {
                prefix = '实体管理员-';
            }
            if (role.roleType == '3') {
                prefix = '一般用户-';
            }
            return prefix + role.roleName;
        },
        addRelCompanyClickFun() { //  新增用户关联公司信息
            this.showCompanyDataDialogVisible = true;
            for (let i = 0; i < this.ruleFormcompanyList.length; i++) {
                for (let k = 0; k < this.allCompanyList.length; k++) {
                    if (this.ruleFormcompanyList[i].id == this.allCompanyList[k].id) {
                        this.allCompanyList.splice(k, 1);
                    }
                }
            }
            this.ruleFormcompanyList.push({});
            this.ruleFormcompanyList.pop({});
        },
        delRelCompanyClickFun() { //  删除用户关联公司信息
            let checkRows = this.$refs.relCompanyTable.selection;
            if (!checkRows || checkRows.length == 0) {
                this.$message.warning('请选择需要删除关联的公司信息！');
                return;
            }
            //数据返回到列表中
            for (let i = 0; i < checkRows.length; i++) {
                this.allCompanyList = this.allCompanyList.concat(checkRows[i]);
            }
            //删除被选中的公司
            for (let i = 0; i < checkRows.length; i++) {
                for (let k = 0; k < this.ruleFormcompanyList.length; k++) {
                    if (this.ruleFormcompanyList[k].id == checkRows[i].id) {
                        this.ruleFormcompanyList.splice(k, 1);
                    }
                }
            }
            this.ruleFormcompanyList.push({});
            this.ruleFormcompanyList.pop({});
        },
        clickCompanyTableRowByChecked(row) {
            this.$refs.companyTable.toggleRowSelection(row);
        },
        clickUserRelCompanyRowByChecked(row) {
            this.$refs.relCompanyTable.toggleRowSelection(row);
        },
        saveUserRelCompanyClickFun() { //  保存用户勾选的公司信息
            if (!this.ruleFormcompanyList) {
                this.ruleFormcompanyList = [];
            }
            let checkRows = this.$refs.companyTable.selection;
            if (!checkRows || checkRows.length == 0) {
                this.$message.warning('请选择需要关联的公司信息！');
                return;
            }
            //显示用户勾选的列表
            for (let i = 0; i < checkRows.length; i++) {
                this.ruleFormcompanyList = this.ruleFormcompanyList.concat(checkRows[i]);
            }
            //删除存在对象
            for (let i = 0; i < checkRows.length; i++) {
                for (let k = 0; k < this.allCompanyList.length; k++) {
                    if (this.allCompanyList[k].id == checkRows[i].id) {
                        this.allCompanyList.splice(k, 1);
                    }
                }
            }
            this.showCompanyDataDialogVisible = false;
        },

        getCompanyDataByCurrGroupId(groupId) { //  用户勾选关联公司：company data
            getCompanyListByGroup(groupId).then(res => {
                if (res.data.success) {
                    this.allCompanyList = JSON.parse(JSON.stringify(res.data.obj));
                } else {
                    res.data.data;
                    this.$message.error('获取当前集团下所有实体信息失败：' + res.data.message);
                }
            }, error => {
                this.$message.error('获取当前集团下所有实体信息失败：' + error);
            });
        },
        getUserAndCompanyMapping(groupId) { //  获取用户已勾选的公司
            getUserAndCompanyMapping(groupId).then(res => {
                if (res.data.success) {
                    this.ruleFormcompanyList = res.data.obj;
                    this.dialogVisible2 = true;
                } else {
                    this.$message.error('获取当前用户下所有实体信息失败：' + res.data.message);
                }
            }, error => {
                this.$message.error('获取当前用户下所有实体信息失败：' + error);
            });
        },
        stateFormat(row, column, cellValue, index) {
            if (row.state == '0') {
                return '正常';
            } else if (row.state == '1') {
                return '停用';
            } else {
                return row.state;
            }
        },
        uploadFile($event) {
            this.upfilename = $event.target.files[0].name;
            var reader = new FileReader();
            let fileData = $event.target.files[0];
            let formData = new FormData();

            formData.append('id', this.id);

            formData.append('uploadFile', fileData);
            this.upfile = formData;

        },
        sureupload() {
            if (this.upfile == '') {
                this.$message.error('请选择文件！');
                return;
            }
            this.uploadExcel(this.upfile);
        },
        handleCommand(e) {
            this.filestate = '';
            this.upfilename = '';
            this.upfile = '';
            this.daorudiag = true;
        },
        /* 上传 */
        uploadExcel(upfile) {
            let params = upfile;
            uploadUserExcel(params).then(res => {
                if (res.data.success) {
                    this.getUserList();
                    this.daorudiag = false;
                }
            });
        },
        /* 接口调用操作 */
        downloadDefaultTemplate() {
            location.href = http.baseURL + 'sys/userImport/downloadDefaultTemplate';
        }
    }
};
</script>

<style scoped lang='less'>
.form {
    margin-right: 30px;
}

/deep/ .el-table--small td {
    padding: 4px 0;
}

/deep/ .el-table__body-wrapper {
    min-height: 200px;
}

.btn {
    display: flex;
    margin-top: 20px;
    margin-bottom: 20px;
}

.pagination {
    margin-top: 15px;
}

.bottombut {
    margin-top: 20px;

    display: flex;
    justify-content: flex-end;
}

.groupusers {
    padding: 0 10px;
}

.top {
}

.center {
    display: flex;
    justify-content: space-between;
}

.center .btn {
    margin-bottom: 15px;
}

.search {
    margin-top: 25px;
}

.el-form {
    display: flex;
    flex-wrap: wrap;
}

.el-form-item {
    width: 50%;
}

.sendinput {
    visibility: hidden;
}

.bt1 {
    width: 80px;
    height: 31px;
    border: 1px solid #e5e5e5;
    border-radius: 3px;
    font-size: 14px;
    cursor: pointer;
    font-weight: 500;
    color: #2f66fc;
}

.areatable {
    margin-top: 27px;
}

.areacontent {
    margin-left: 21px;
}

/* 	弹框底部确认按钮 */
.buttomanniu:extend(.end-flex) {
    margin-top: 30px;
}

.buttomanniu > div:nth-of-type(1):extend(.Centerhorizontally) {
    width: 93px;
    height: 32px;
    background: #0080FF;
    border-radius: 2px;
    font-size: 15px;
    font-weight: 400;
    cursor: pointer;
    color: #FFFFFF;
}

.buttomanniu > div:nth-of-type(2):extend(.Centerhorizontally) {
    width: 91px;
    height: 30px;
    border-radius: 2px;
    font-size: 15px;
    font-weight: 400;
    cursor: pointer;
    margin-left: 53px;
    color: #333333;
    border: 1px solid #999999;
}
</style>
